if ((typeof myShopify) === 'undefined') {
  myShopify = {};
}

myShopify.addItem = function(id, qty, cb) {
  var query = {
    'type': 'POST',
    'url': '/cart/add.js',
    'data': 'quantity=' + qty + '&id=' + id,
    'dataType': 'json',
    success: function(response){
      cb(response);
    },
    error: function(response){
      response = $.parseJSON(response.responseText);
      cb(response);
    }
  }

  $.ajax(query);
}

myShopify.getCart = function(cb){
  var query = {
    type: 'POST',
    url: '/cart.js',
    dataType: 'json',
    complete: function(response){
      var cart = $.parseJSON(response.responseText);
      if(typeof(cb === "function")){
        cb(cart);
      }
    }
  }
  $.ajax(query);
}